/* eslint-disable max-len */

import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import eventLogFields from '../../fields/eventLogFields';
import { POS_TERMINALS } from '../apiUrls';
import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';


/**
 *
 * @param root0
 * @param root0.items
 * @param root0.totalResults
 * @returns {Object}
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const mappedItems = items.map(item => ({
        [eventLogFields.NETWORK_INFORMATION.key]: {
            [eventLogFields.NETWORK_INFORMATION.SOURCE_ADDRESS.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.NETWORK_INFORMATION.SOURCE_ADDRESS)),
            [eventLogFields.NETWORK_INFORMATION.ENTRY_ADDRESS.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.NETWORK_INFORMATION.ENTRY_ADDRESS)),
            [eventLogFields.NETWORK_INFORMATION.SSL_VERSION.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.NETWORK_INFORMATION.SSL_VERSION)),
            [eventLogFields.NETWORK_INFORMATION.ORIGIN_PORT.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.NETWORK_INFORMATION.ORIGIN_PORT)),
            [eventLogFields.NETWORK_INFORMATION.ENTRY_PORT.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.NETWORK_INFORMATION.ENTRY_PORT))
        },
        [eventLogFields.DEVICE_INFORMATION.key]: {
            [eventLogFields.DEVICE_INFORMATION.NETWORK_INTERFACE_TYPE.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.DEVICE_INFORMATION.NETWORK_INTERFACE_TYPE)),
            [eventLogFields.DEVICE_INFORMATION.ICCID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.DEVICE_INFORMATION.ICCID)),
            [eventLogFields.DEVICE_INFORMATION.ICCID_OPERATOR.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.DEVICE_INFORMATION.ICCID_OPERATOR)),
            [eventLogFields.DEVICE_INFORMATION.POS_TERMINAL_UUID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.DEVICE_INFORMATION.POS_TERMINAL_UUID))
        },
        [eventLogFields.METRICS_INFORMATION.key]: {
            [eventLogFields.METRICS_INFORMATION.STARTED_AT.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.METRICS_INFORMATION.STARTED_AT)),
            [eventLogFields.METRICS_INFORMATION.DURATION.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.METRICS_INFORMATION.DURATION))
        },
        [eventLogFields.FINANCIAL_INFORMATION.key]: {
            [eventLogFields.FINANCIAL_INFORMATION.OPERATIONS.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.FINANCIAL_INFORMATION.OPERATIONS)),
            [eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.key]: {
                [eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.ACCEPTANCE_AGREEMENT_NUMBER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.ACCEPTANCE_AGREEMENT_NUMBER)),
                [eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.ACCEPTANCE_SYSTEM_NUMBER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.ACCEPTANCE_SYSTEM_NUMBER)),
                [eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.BANK_CODE.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.BANK_CODE)),
                [eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.COMPANY_REGISTRATION_NUMBER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.COMPANY_REGISTRATION_NUMBER)),
                [eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.APPLICATION_ID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.APPLICATION_ID))
            }
        },
        [eventLogFields.DESTINATION_INFORMATION.key]: {
            [eventLogFields.DESTINATION_INFORMATION.ADDRESS.key]: {
                [eventLogFields.DESTINATION_INFORMATION.ADDRESS.X121_ADDRESS.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(eventLogFields.DESTINATION_INFORMATION.ADDRESS.X121_ADDRESS))
            }
        },
        [eventLogFields.APPLICATION.key]: item[eventLogFields.APPLICATION.key],
        [eventLogFields.VERSION_CB.key]: item[eventLogFields.VERSION_CB.key]
    }));

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetEventLogs = ({ query, posTerminalId }, enabled) => {
    return {
        queryKey: [POS_TERMINALS.EVENT_LOGS_COLLECTION.queryKey, posTerminalId, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(replaceParameters(POS_TERMINALS.EVENT_LOGS_COLLECTION.url, { posTerminalId: posTerminalId }), query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetEventLogs;